module.exports = __webpack_public_path__ + "static/media/Agenda3.30eec7ce.jpg";